export const FileSkipped = ({ fill = '#001965' }: { fill?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.3471 5.34304L12.9894 2.98539C12.6768 2.67268 12.2528 2.49686 11.8106 2.49686H5.83142C4.91057 2.49686 4.16406 3.24336 4.16406 4.16422V15.8357C4.16406 16.7566 4.91057 17.5031 5.83142 17.5031H14.1682C15.0891 17.5031 15.8356 16.7566 15.8356 15.8357V6.52187C15.8356 6.07969 15.6598 5.65566 15.3471 5.34304Z"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M11.251 12.501L8.75 9.58313"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.75 12.501L11.251 9.58313"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);
